package macha.sh.kotlin.components.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.icons.CloseIcon
import com.varabyte.kobweb.silk.components.icons.HamburgerIcon
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.components.overlay.Overlay
import com.varabyte.kobweb.silk.components.overlay.OverlayVars
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import macha.sh.kotlin.SiteColors
import macha.sh.kotlin.SiteModifiers
import macha.sh.kotlin.components.layouts.SiteContentMaxWidth
import macha.sh.kotlin.components.widgets.IconButton
import macha.sh.kotlin.integrations.PlayMode
import macha.sh.kotlin.integrations.powerGlitch
import macha.sh.kotlin.SiteTypography
import macha.sh.kotlin.applyFont
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Style
import org.jetbrains.compose.web.dom.Text

object Banner {
    private val Mods = SiteModifiers.Navi
    @Composable
    fun Content() {
        Box(Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
            Box(modifier = Mods.banner(), contentAlignment = Alignment.Center) { Style { 
                ".nav-glitch" {
                    property("position", "relative")
                    property("display", "inline-block")
                    property("color", "var(--glitch-base, currentColor)")}
                ".nav-glitch[data-islayer=\"true\"]" { 
                    property("mix-blend-mode", "screen")}
                ".nav-glitch[data-islayer=\"true\"]:nth-of-type(3n + 2)" {
                    property("color", "var(--glitch-color-1, currentColor)")}
                ".nav-glitch[data-islayer=\"true\"]:nth-of-type(3n + 3)" {
                    property("color", "var(--glitch-color-2, currentColor)")}
                ".nav-glitch[data-islayer=\"true\"]:nth-of-type(3n + 4)" {
                    property("color", "var(--glitch-color-3, currentColor)")}
                }
                Span(attrs = {
                    classes("nav-glitch")
                    attr("aria-hidden", "true")
                    style {
                        property("--glitch-base", SiteColors.BannerGlitch.Base)
                        property("--glitch-color-1", SiteColors.BannerGlitch.ColorA)
                        property("--glitch-color-2", SiteColors.BannerGlitch.ColorB)
                        property("--glitch-color-3", SiteColors.BannerGlitch.ColorC)
                    }
                    powerGlitch {
                        playMode(PlayMode.ALWAYS)
                        timing(durationMs = 5000)
                        glitchTimeSpan(start = 0.05, end = 0.10)
                        shake(velocity = 30, amplitudeX = 0.3, amplitudeY = 0.25)
                        slice(hueRotate = false)
                    }
                }) {
                    Text("MACHA")
                }
            }
        }
    }
}